import { render, staticRenderFns } from "./ed-class-builder-placeholder.component.vue?vue&type=template&id=357c3954&scoped=true&"
import script from "./ed-class-builder-placeholder.component.ts?vue&type=script&lang=ts&"
export * from "./ed-class-builder-placeholder.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-class-builder-placeholder.component.scss?vue&type=style&index=0&id=357c3954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357c3954",
  null
  
)

export default component.exports